export const getIsoFormat = (date: Date): string => {
  const year = date.getFullYear();
  let month = (date.getMonth() + 1).toString();

  let day = date.getDate().toString();
  if (parseInt(day, 10) < 10) {
    day = '0' + day;
  }

  if (parseInt(month) < 10) {
    month = '0' + month;
  }

  //why not date.toISOString().slice(0, 10); // YYYY-MM-DD
  return year + '-' + month + '-' + day;
};
